import { Injectable, Signal, computed, inject } from '@angular/core';
import { TrunkBaseConfigurationService } from '@core/services/trunk-base-configuration/trunk-base-configuration.service';
import { WsSyncState } from '../state/ws-sync.state';

@Injectable({ providedIn: 'root' })
export class GetWsSyncStateUseCase {
  private readonly state = inject(WsSyncState);
  private readonly trunkBaseConfigurationService = inject(TrunkBaseConfigurationService);

  private get flagEnabled(): boolean {
    return this.trunkBaseConfigurationService.CIAContenidoWS;
  }

  execute(idMarca: string, idSubmarca: string): Signal<boolean> {
    const activeSig = this.state.isSyncActive(idMarca, idSubmarca);
    return computed(() => this.flagEnabled && activeSig());
  }

  pending(idMarca: string, idSubmarca: string): Signal<boolean> {
    const pendingSig = this.state.isPending(idMarca, idSubmarca);
    return computed(() => this.flagEnabled && pendingSig());
  }

  blocking(idMarca: string, idSubmarca: string): Signal<boolean> {
    const pendingSig = this.state.isPending(idMarca, idSubmarca);
    const activeSig = this.state.isSyncActive(idMarca, idSubmarca);
    return computed(() => this.flagEnabled && (pendingSig() || activeSig()));
  }

  hasAnyPending(): Signal<boolean> {
    return computed(() => this.flagEnabled && this.state.hasAnyPending());
  }

  snapshot(idMarca: string, idSubmarca: string): boolean {
    return this.flagEnabled && this.state.getSync(idMarca, idSubmarca);
  }
}
